import config from '../../../config';
import { PredefinedMilisecondsTypeEnum } from '../../enums';
import { NullableString } from '../../util/types';
import { SocketRequestType } from '../subscription/types';

import { BaseWebSocketService } from './BaseWebSocket.service';

export class GatewayWebSocketService extends BaseWebSocketService<SocketRequestType> {
  private static instance: GatewayWebSocketService;

  // eslint-disable-next-line no-useless-constructor
  private constructor(token: NullableString, loginTimeout: PredefinedMilisecondsTypeEnum) {
    super(token, loginTimeout);
    // In order to avoid having multiple instances constructor is set as private
  }

  static getInstance(
    token: string,
    loginTimeout = PredefinedMilisecondsTypeEnum.fiveSeconds,
  ): GatewayWebSocketService {
    if (!this.instance) {
      this.instance = new GatewayWebSocketService(token, loginTimeout);
    }

    return this.instance;
  }

  protected getBaseUrl(): string {
    return `wss://${config.gateway.url}/push`;
  }

  protected cacheResponse(): string {
    throw Error('Not implemented yet');
  }
}
